import { IPresenterOwner, Logger, Presenter } from 'wdc-cube'
import { TheConsumerMarketPresenter } from '../tcm_presenter'
import { AppliedFilterSummary, FilterPaneScope, IFilterScope, KeywordOption } from '../tcm_scopes'
import { buildSummary, summarizeFilterScope } from '../tcm_filter_summary'

import FilterManager from '../tcm_filter_manager'
import { TcmPresenterForFilterCatalog } from './tcm_filter_catalog_presenter'
import { TcmPresenterForAtivEconomica } from './tcm_filter_presenter_for_ae'
import { TcmPresenterFilterForCnpj } from './tcm_filter_presenter_for_cnpj'
import { TcmPresenterForDateFilter } from './tcm_filter_presenter_for_date'
import { TcmPresenterForNumberFilter } from './tcm_filter_presenter_for_number'
import { TcmPresenterForStringFilter } from './tcm_filter_presenter_for_string'
import { TcmPresenterForStringKeywordFilter } from './tcm_filter_presenter_for_string_keyword'
import { FilterPresenter } from './tcm_filter_types'

import { AppStorage } from 'src/utils'
import { TheConsumerMarketKeys } from '../tcm_keys'
import {
    DominioPj,
    DominioPjOpcao,
    EmpresaFilter,
    MatrizOrFilial,
    SituacaoCadastral,
    TheConsumerMarketService
} from '../tcm_service'
import { TcmPresenterForCbo } from './tcm_filter_presenter_for_cbo'
import { TcmPresenterForSituacaoCadastral } from './tcm_filter_presenter_for_situacao_cadastral'
import { TcmPresenterForStringMultiSelectFilter } from './tcm_filter_presenter_for_string_multi_select'
import { TcmPresenterForSelectFilter } from './tcm_filter_select_presenter'

const service = TheConsumerMarketService.singleton()

const appStorage = AppStorage.singleton()

const LOG = Logger.get('TCM-FILTER-PANE')

export class TcmPresenterForFilterPane extends Presenter<FilterPaneScope, TheConsumerMarketPresenter> {
    // Constructor

    // prettier-ignore
    constructor(owner: TheConsumerMarketPresenter) {
        super(owner, owner.scope.filterPane)
        this.filterManager = owner.filterManager

        const mgr = owner.filterManager

        this.catalogFilter = new TcmPresenterForFilterCatalog(this)

        const add = this.filterPresenters.push.bind(this.filterPresenters)
        add(this.nomeRazaoSocial = new TcmPresenterForStringFilter(this, this.scope.nomeEmpresa, mgr.empresaRazaoSocial, this.searchByRazaoSocial.bind(this)))
        add(this.nomeFantasia = new TcmPresenterForStringFilter(this, this.scope.nomeFantasia, mgr.empresaNomeFantasia, this.searchByNomeFantasia.bind(this)))
        add(this.empresaNomeMatriz = new TcmPresenterForStringFilter(this, this.scope.nomeMatriz, mgr.empresaNomeMatriz, this.searchByNomeMatriz.bind(this)))
        add(this.codigo = new TcmPresenterFilterForCnpj(this, this.scope.cnpj, mgr.empresaCodigo))
        add(this.cnpjMatriz = new TcmPresenterFilterForCnpj(this, this.scope.cnpjMatriz, mgr.empresaCnpjMatriz))
        add(this.cnpjGrupo = new TcmPresenterFilterForCnpj(this, this.scope.cnpjGrupo, mgr.empresaCnpjGrupo))
        add(this.dtInicioAtividade = new TcmPresenterForDateFilter(this, this.scope.dtInicioAtividade, mgr.inicioAtividade))
        
        add(this.situacaoCadastral = new TcmPresenterForSituacaoCadastral(this, this.scope.situacaoCadastral, mgr.situacaoCadastral, this.__getAllSituacaoCadastral.bind(this)))
        add(this.dtSituacaoCadastral = new TcmPresenterForDateFilter(this, this.scope.dtSituacaoCadastral, mgr.dtSituacaoCadastral))
        add(this.dtCompetenciaInicioAtividade = new TcmPresenterForDateFilter(this, this.scope.dtCompetenciaInicioAtividade, mgr.dtCompetenciaInicioAtividade))

        add(this.socioNome = new TcmPresenterForStringFilter(this, this.scope.socioNome, mgr.socioNome, this.searchSocioByNome.bind(this)))
        add(this.prfNome = new TcmPresenterForStringFilter(this, this.scope.prfNome, mgr.prfNome, this.searchMedicoByNome.bind(this)))
        add(this.pesNome = new TcmPresenterForStringFilter(this, this.scope.pesNome, mgr.pesNome, this.searchEmpregadoByNome.bind(this)))

        add(this.naturezaJuridicaCodes = new TcmPresenterForStringMultiSelectFilter(this, this.scope.naturezaJuridicaCodes, mgr.naturezaJuridicaCodes, this.__getAllNaturezasJuridicas.bind(this)))
        add(this.naturezaJuridicaGrupoCodes = new TcmPresenterForStringMultiSelectFilter(this, this.scope.naturezaJuridicaGrupoCodes, mgr.naturezaJuridicaGrupoCodes, async () => NATUREZA_JURIDICA_GRUPOS))
        add(this.naturezaJuridicaPublicaPrivadaCodes = new TcmPresenterForSelectFilter(this, this.scope.naturezaJuridicaPublicaPrivadaCodes, mgr.naturezaJuridicaPublicaPrivadaCodes))
        add(this.tipoCnaeCodes = new TcmPresenterForAtivEconomica(this, this.scope.tipoCnaeTexts, mgr.tipoAtividadeEconomicaCodes, this.__getAllCNAE.bind(this)))
        add(this.tipoEstabelecimentoSaudeCodes = new TcmPresenterForStringMultiSelectFilter(this, this.scope.tipoEstabelecimentoSaudeCodes, mgr.tipoEstabelecimentoSaudeCodes, this.__searchAllCnesTipos.bind(this)))
        add(this.porteEstabelecimentoSaudeCodes = new TcmPresenterForStringMultiSelectFilter(this, this.scope.porteEstabelecimentoSaudeCodes, mgr.porteEstabelecimentoSaudeCodes, this.__searchAllCnesPortes.bind(this)))
        add(this.cnaeClasseCodes = new TcmPresenterForStringMultiSelectFilter(this, this.scope.cnaeClasseCodes, mgr.cnaeClasseCodes, this.__getAllCNAEClasse.bind(this)))
        add(this.cnaeDivisaoCodes = new TcmPresenterForStringMultiSelectFilter(this, this.scope.cnaeDivisaoCodes, mgr.cnaeDivisaoCodes, this.__getAllCNAEDivisao.bind(this)))
        add(this.cnaeGrupoCodes = new TcmPresenterForStringMultiSelectFilter(this, this.scope.cnaeGrupoCodes, mgr.cnaeGrupoCodes, this.__getAllCNAEGrupo.bind(this)))
        add(this.cnaeSecaoCodes = new TcmPresenterForStringMultiSelectFilter(this, this.scope.cnaeSecaoCodes, mgr.cnaeSecaoCodes, this.__getAllCNAESecao.bind(this)))
        add(this.cnaeSetorCods = new TcmPresenterForStringMultiSelectFilter(this, this.scope.cnaeSetorCods, mgr.cnaeSetorCods, this.__getAllCNAESetor.bind(this)))
        
        add(this.cnesTexts = new TcmPresenterForStringKeywordFilter(this, this.scope.cnesTexts, mgr.empresaCnes))
        // "Não está em branco" lista todos os estabelecimentos de saúde (pj-cnes só existe em quem tem CNES)
        this.scope.cnesTexts.acceptBlankValues = true

        add(this.uf = new TcmPresenterForStringMultiSelectFilter(this, this.scope.uf, mgr.enderecoUfs, this.searchAllUFs.bind(this)))
        add(this.bairroTexts = new TcmPresenterForStringFilter(this, this.scope.bairroTexts, mgr.enderecoBairroTexts, this.searchByBairroDescricao.bind(this)))
        add(this.cidadeCodes = new TcmPresenterForStringMultiSelectFilter(this, this.scope.cidadeCodes, mgr.enderecoCidadeCodes, this.searchAllCidades.bind(this)))
        add(this.regiaoMetropolitanaCodes = new TcmPresenterForStringMultiSelectFilter(this, this.scope.regiaoMetropolitanaCodes, mgr.enderecoRegiaoMetropolitanaCodes, this.__getAllRegioesMetropolitanas.bind(this)))
        add(this.scoreRiscos = new TcmPresenterForStringMultiSelectFilter(this, this.scope.scoreRiscos, mgr.scoreRiscos, this.__getScoreRiscoList.bind(this)))
        
        add(this.cboCodes = new TcmPresenterForCbo(this, this.scope.cboCodes, mgr.cboCodes, this.__searchAllCBOs.bind(this)))
        add(this.cboTexts = new TcmPresenterForStringFilter(this, this.scope.cboTexts, mgr.cboTexts))
        add(this.pesCboCodes = new TcmPresenterForCbo(this, this.scope.pesCboCodes, mgr.pesCboCodes, this.__searchAllPesCBOs.bind(this)))
        add(this.pesCboTexts = new TcmPresenterForStringFilter(this, this.scope.pesCboTexts, mgr.pesCboTexts))
        add(this.cboCategorias = new TcmPresenterForStringMultiSelectFilter(this, this.scope.cboCategorias, mgr.cboCategorias, searchAllPrfCboCategorias))
        add(this.pesCboCategorias = new TcmPresenterForStringMultiSelectFilter(this, this.scope.pesCboCategorias, mgr.pesCboCategorias, searchAllPesCboCategorias))

        for (const presenter of [this.socioNome, this.prfNome, this.pesNome, this.cboTexts, this.pesCboTexts, this.cboCategorias, this.pesCboCategorias]) {
            presenter.acceptBlankValues = false
        }

        add(this.matrizFilial = new TcmPresenterForSelectFilter(this, this.scope.matrizFilial, mgr.matrizFilial))
        add(this.regimeTributario = new TcmPresenterForStringMultiSelectFilter(this, this.scope.regimeTributario, mgr.regimeTributario, this.__getRegimeTributarioList.bind(this)))
        add(this.porteReceitaFederal = new TcmPresenterForStringMultiSelectFilter(this, this.scope.porteReceitaFederal, mgr.porteReceitaFederal, this.__getPorteEmpresaList.bind(this)))
        add(this.regiaoGeograficaImediataCodes = new TcmPresenterForStringMultiSelectFilter(this, this.scope.regiaoGeograficaImediataCodes, mgr.regiaoGeograficaImediataCodes, this.__getAllRegioesGeoImediatas.bind(this)))
        add(this.regiaoGeograficaIntermediariaCodes = new TcmPresenterForStringMultiSelectFilter(this, this.scope.regiaoGeograficaIntermediariaCodes, mgr.regiaoGeograficaIntermediariaCodes, this.__getAllRegioesGeoIntermediarias.bind(this)))
        add(this.portePorFuncionarios = new TcmPresenterForStringMultiSelectFilter(this, this.scope.portePorFuncionarios, mgr.portePorFuncionarios, async () => PORTE_OPTIONS))
        add(this.portePorFaturamentoEstimadoCnpj = new TcmPresenterForStringMultiSelectFilter(this, this.scope.portePorFaturamentoEstimadoCnpj, mgr.portePorFaturamentoEstimadoCnpj, async () => PORTE_OPTIONS))
        add(this.portePorFaturamentoEstimadoGrupo = new TcmPresenterForStringMultiSelectFilter(this, this.scope.portePorFaturamentoEstimadoGrupo, mgr.portePorFaturamentoEstimadoGrupo, async () => PORTE_OPTIONS))
        add(this.cadeiaValorSaude = new TcmPresenterForSelectFilter(this, this.scope.cadeiaValorSaude, mgr.cadeiaValorSaude))
        add(this.totalEmpresaGrupo = new TcmPresenterForNumberFilter(this, this.scope.totalEmpresaGrupo, mgr.totalEmpresasNoGrupo))
        add(this.totalEmpresaCapSocial = new TcmPresenterForNumberFilter(this, this.scope.totalEmpresaCapSocial, mgr.capitalSocial))
        add(this.totalFuncionarios = new TcmPresenterForNumberFilter(this, this.scope.totalFuncionarios, mgr.totalFuncionarios))
        add(this.totalFuncionarios_0_a_18 = new TcmPresenterForNumberFilter(this, this.scope.totalFuncionarios_0_a_18, mgr.totalFuncionarios_0_a_18))
        add(this.totalFuncionarios_19_a_33 = new TcmPresenterForNumberFilter(this, this.scope.totalFuncionarios_19_a_33, mgr.totalFuncionarios_19_a_33))
        add(this.totalFuncionarios_34_a_48 = new TcmPresenterForNumberFilter(this, this.scope.totalFuncionarios_34_a_48, mgr.totalFuncionarios_34_a_48))
        add(this.totalFuncionarios_49_a_58 = new TcmPresenterForNumberFilter(this, this.scope.totalFuncionarios_49_a_58, mgr.totalFuncionarios_49_a_58))
        add(this.totalFuncionarios_59_ou_mais = new TcmPresenterForNumberFilter(this, this.scope.totalFuncionarios_59_ou_mais, mgr.totalFuncionarios_59_ou_mais))
        add(this.totalFuncionariosFemininos = new TcmPresenterForNumberFilter(this, this.scope.totalFuncionariosFemininos, mgr.totalFuncionariosFemininos))
        add(this.totalFuncionariosMasculinos = new TcmPresenterForNumberFilter(this, this.scope.totalFuncionariosMasculinos, mgr.totalFuncionariosMasculinos))
        add(this.totalFuncionariosDoGrupo = new TcmPresenterForNumberFilter(this, this.scope.totalFuncionariosDoGrupo, mgr.totalFuncionariosDoGrupo))

        add(this.faixaFaturamentoAnual = new TcmPresenterForNumberFilter(this, this.scope.faixaFaturamentoAnual, mgr.faturamentoEstimado))
        add(this.faixaFaturamentoConsolidadoGrupo = new TcmPresenterForNumberFilter(this, this.scope.faixaFaturamentoConsolidadoGrupo, mgr.faturamentoEstimadoGrupo))

        add(this.idadeEmpresa = new TcmPresenterForNumberFilter(this, this.scope.idadeEmpresa, mgr.idadeEmpresaEmAnos))

        for (const presenter of [this.naturezaJuridicaGrupoCodes, this.portePorFuncionarios, this.portePorFaturamentoEstimadoCnpj, this.portePorFaturamentoEstimadoGrupo]) {
            presenter.acceptBlankValues = false
        }

        // colunas da listagem de empresas que não tinham filtro
        add(this.matrizUfs = new TcmPresenterForStringMultiSelectFilter(this, this.scope.matrizUfs, mgr.matrizUfs, this.searchAllUFs.bind(this)))
        add(this.cep = new TcmPresenterForStringKeywordFilter(this, this.scope.cep, mgr.enderecoCeps))
        add(this.logradouro = new TcmPresenterForStringFilter(this, this.scope.logradouro, mgr.enderecoRuaTexts))
        add(this.enderecoNumeros = new TcmPresenterForStringKeywordFilter(this, this.scope.enderecoNumeros, mgr.enderecoNumeros))
        add(this.enderecoComplementoTexts = new TcmPresenterForStringFilter(this, this.scope.enderecoComplementoTexts, mgr.enderecoComplementoTexts))
        add(this.enderecoLatitude = new TcmPresenterForNumberFilter(this, this.scope.enderecoLatitude, mgr.enderecoLatitude))
        add(this.enderecoLongitude = new TcmPresenterForNumberFilter(this, this.scope.enderecoLongitude, mgr.enderecoLongitude))
        add(this.telefone1 = new TcmPresenterForStringFilter(this, this.scope.telefone1, mgr.telefone1))
        add(this.telefone2 = new TcmPresenterForStringFilter(this, this.scope.telefone2, mgr.telefone2))
        add(this.email = new TcmPresenterForStringFilter(this, this.scope.email, mgr.email))
        add(this.totalFiliais = new TcmPresenterForNumberFilter(this, this.scope.totalFiliais, mgr.totalFiliais))
        add(this.totalFuncionariosMatrizEFiliais = new TcmPresenterForNumberFilter(this, this.scope.totalFuncionariosMatrizEFiliais, mgr.totalFuncionariosMatrizEFiliais))
        add(this.salarioTotal = new TcmPresenterForNumberFilter(this, this.scope.salarioTotal, mgr.salarioTotal))
        add(this.salarioTotalGrupo = new TcmPresenterForNumberFilter(this, this.scope.salarioTotalGrupo, mgr.salarioTotalGrupo))
        add(this.optanteSimples = new TcmPresenterForStringMultiSelectFilter(this, this.scope.optanteSimples, mgr.optanteSimples, this.__getOptanteSimplesList.bind(this)))
        add(this.optanteMei = new TcmPresenterForStringMultiSelectFilter(this, this.scope.optanteMei, mgr.optanteMei, this.__getOptanteMeiList.bind(this)))
        add(this.webNomeTexts = new TcmPresenterForStringFilter(this, this.scope.webNomeTexts, mgr.webNomeTexts))
        add(this.webCategoriasTexts = new TcmPresenterForStringFilter(this, this.scope.webCategoriasTexts, mgr.webCategoriasTexts))
        add(this.webNota = new TcmPresenterForNumberFilter(this, this.scope.webNota, mgr.webNota))
        add(this.webQtdAvaliacoes = new TcmPresenterForNumberFilter(this, this.scope.webQtdAvaliacoes, mgr.webQtdAvaliacoes))
        add(this.webTempoMedio = new TcmPresenterForNumberFilter(this, this.scope.webTempoMedio, mgr.webTempoMedio))
        add(this.webSite = new TcmPresenterForStringFilter(this, this.scope.webSite, mgr.webSite))
        add(this.webTelefone = new TcmPresenterForStringFilter(this, this.scope.webTelefone, mgr.webTelefone))
    }

    // :: Getters

    get tmPresenter() {
        return super.owner as TheConsumerMarketPresenter
    }

    // :: Fields

    readonly filterManager: FilterManager
    readonly catalogFilter: TcmPresenterForFilterCatalog

    private readonly filterPresenters: FilterPresenter<IFilterScope, IPresenterOwner>[] = []

    public readonly nomeRazaoSocial: TcmPresenterForStringFilter
    public readonly nomeFantasia: TcmPresenterForStringFilter
    public readonly empresaNomeMatriz: TcmPresenterForStringFilter
    public readonly codigo: TcmPresenterFilterForCnpj
    public readonly cnpjMatriz: TcmPresenterFilterForCnpj
    public readonly cnpjGrupo: TcmPresenterFilterForCnpj
    public readonly dtInicioAtividade: TcmPresenterForDateFilter
    public readonly situacaoCadastral: TcmPresenterForSituacaoCadastral
    public readonly dtSituacaoCadastral: TcmPresenterForDateFilter
    public readonly dtCompetenciaInicioAtividade: TcmPresenterForDateFilter

    public readonly naturezaJuridicaCodes: TcmPresenterForStringMultiSelectFilter
    public readonly naturezaJuridicaGrupoCodes: TcmPresenterForStringMultiSelectFilter
    public readonly naturezaJuridicaPublicaPrivadaCodes: TcmPresenterForSelectFilter
    public readonly tipoCnaeCodes: TcmPresenterForAtivEconomica
    public readonly tipoEstabelecimentoSaudeCodes: TcmPresenterForStringMultiSelectFilter
    public readonly porteEstabelecimentoSaudeCodes: TcmPresenterForStringMultiSelectFilter
    public readonly cnaeClasseCodes: TcmPresenterForStringMultiSelectFilter
    public readonly cnaeDivisaoCodes: TcmPresenterForStringMultiSelectFilter
    public readonly cnaeGrupoCodes: TcmPresenterForStringMultiSelectFilter
    public readonly cnaeSecaoCodes: TcmPresenterForStringMultiSelectFilter
    public readonly cnaeSetorCods: TcmPresenterForStringMultiSelectFilter
    public readonly cnesTexts: TcmPresenterForStringKeywordFilter
    public readonly uf: TcmPresenterForStringMultiSelectFilter
    public readonly bairroTexts: TcmPresenterForStringFilter
    public readonly cidadeCodes: TcmPresenterForStringMultiSelectFilter
    public readonly regiaoMetropolitanaCodes: TcmPresenterForStringMultiSelectFilter
    public readonly scoreRiscos: TcmPresenterForStringMultiSelectFilter
    public readonly cboCodes: TcmPresenterForCbo
    public readonly cboTexts: TcmPresenterForStringFilter
    public readonly pesCboCodes: TcmPresenterForCbo
    public readonly pesCboTexts: TcmPresenterForStringFilter
    public readonly cboCategorias: TcmPresenterForStringMultiSelectFilter
    public readonly pesCboCategorias: TcmPresenterForStringMultiSelectFilter

    public readonly socioNome: TcmPresenterForStringFilter
    public readonly prfNome: TcmPresenterForStringFilter
    public readonly pesNome: TcmPresenterForStringFilter

    public readonly totalEmpresaGrupo: TcmPresenterForNumberFilter
    public readonly totalEmpresaCapSocial: TcmPresenterForNumberFilter
    public readonly totalFuncionarios: TcmPresenterForNumberFilter
    public readonly totalFuncionarios_0_a_18: TcmPresenterForNumberFilter
    public readonly totalFuncionarios_19_a_33: TcmPresenterForNumberFilter
    public readonly totalFuncionarios_34_a_48: TcmPresenterForNumberFilter
    public readonly totalFuncionarios_49_a_58: TcmPresenterForNumberFilter
    public readonly totalFuncionarios_59_ou_mais: TcmPresenterForNumberFilter
    public readonly totalFuncionariosFemininos: TcmPresenterForNumberFilter
    public readonly totalFuncionariosMasculinos: TcmPresenterForNumberFilter
    public readonly totalFuncionariosDoGrupo: TcmPresenterForNumberFilter
    public readonly faixaFaturamentoAnual: TcmPresenterForNumberFilter
    public readonly faixaFaturamentoConsolidadoGrupo: TcmPresenterForNumberFilter
    public readonly idadeEmpresa: TcmPresenterForNumberFilter

    public readonly matrizFilial: TcmPresenterForSelectFilter
    public readonly regimeTributario: TcmPresenterForStringMultiSelectFilter
    public readonly porteReceitaFederal: TcmPresenterForStringMultiSelectFilter
    public readonly regiaoGeograficaImediataCodes: TcmPresenterForStringMultiSelectFilter
    public readonly regiaoGeograficaIntermediariaCodes: TcmPresenterForStringMultiSelectFilter
    public readonly portePorFuncionarios: TcmPresenterForStringMultiSelectFilter
    public readonly portePorFaturamentoEstimadoCnpj: TcmPresenterForStringMultiSelectFilter
    public readonly portePorFaturamentoEstimadoGrupo: TcmPresenterForStringMultiSelectFilter
    public readonly cadeiaValorSaude: TcmPresenterForSelectFilter

    // colunas da listagem de empresas que não tinham filtro
    public readonly matrizUfs: TcmPresenterForStringMultiSelectFilter
    public readonly cep: TcmPresenterForStringKeywordFilter
    public readonly logradouro: TcmPresenterForStringFilter
    public readonly enderecoNumeros: TcmPresenterForStringKeywordFilter
    public readonly enderecoComplementoTexts: TcmPresenterForStringFilter
    public readonly enderecoLatitude: TcmPresenterForNumberFilter
    public readonly enderecoLongitude: TcmPresenterForNumberFilter
    public readonly telefone1: TcmPresenterForStringFilter
    public readonly telefone2: TcmPresenterForStringFilter
    public readonly email: TcmPresenterForStringFilter
    public readonly totalFiliais: TcmPresenterForNumberFilter
    public readonly totalFuncionariosMatrizEFiliais: TcmPresenterForNumberFilter
    public readonly salarioTotal: TcmPresenterForNumberFilter
    public readonly salarioTotalGrupo: TcmPresenterForNumberFilter
    public readonly optanteSimples: TcmPresenterForStringMultiSelectFilter
    public readonly optanteMei: TcmPresenterForStringMultiSelectFilter
    public readonly webNomeTexts: TcmPresenterForStringFilter
    public readonly webCategoriasTexts: TcmPresenterForStringFilter
    public readonly webNota: TcmPresenterForNumberFilter
    public readonly webQtdAvaliacoes: TcmPresenterForNumberFilter
    public readonly webTempoMedio: TcmPresenterForNumberFilter
    public readonly webSite: TcmPresenterForStringFilter
    public readonly webTelefone: TcmPresenterForStringFilter

    // :: API

    async initialize() {
        this.scope.update = this.update
        this.scope.onToggleExpanded = this.action(this.__handleToggleExpantion)
        this.scope.onClearFilters = this.action(this.__handleClearFilters)
        this.scope.onApply = this.action(this.__handleApply)
        this.scope.onSearchFilterChanged = this.action(this.__handleSearchFilterChanged)

        this.scope.enchenteRs2024.update = this.update
        this.scope.enchenteRs2024.onChange = this.action(this.__handleEnchenteRs2024ActiveChange)

        await this.catalogFilter.prepare()

        // As listas lidas do índice custam ~10 s na primeira consulta depois de uma troca de
        // índice (depois o ES responde do cache). Pedir já na abertura do painel evita que
        // essa espera caia no clique de quem abre o filtro.
        for (const dominio of DOMINIOS_PRE_CARREGADOS) {
            getDominioPjOptions(dominio).catch((cause) => LOG.error(`opções de ${dominio}: ${cause}`))
        }

        let orderGen = 1
        await this.nomeRazaoSocial.prepare(orderGen++, 'Nome Empresa')
        await this.nomeFantasia.prepare(orderGen++, 'Nome Fantasia')
        await this.codigo.prepare(orderGen++, 'CNPJ')
        await this.cnpjMatriz.prepare(orderGen++, 'CNPJ Matriz')
        await this.empresaNomeMatriz.prepare(orderGen++, 'Nome Matriz')
        await this.cnpjGrupo.prepare(orderGen++, 'CNPJ Grupo')
        await this.matrizUfs.prepare(orderGen++, 'UF Matriz')
        await this.dtInicioAtividade.prepare(orderGen++, 'Início Atividade')
        await this.situacaoCadastral.prepare(orderGen++, 'Situação Cadastral')
        await this.dtSituacaoCadastral.prepare(orderGen++, 'Data Situação Cadastral')
        await this.dtCompetenciaInicioAtividade.prepare(orderGen++, 'Competência Início Atividade')
        await this.uf.prepare(orderGen++, 'UF')
        await this.bairroTexts.prepare(orderGen++, 'Bairro - Nome')
        await this.cidadeCodes.prepare(orderGen++, 'Município')
        await this.regiaoMetropolitanaCodes.prepare(orderGen++, 'Região Metropolitana')
        await this.cep.prepare(orderGen++, 'CEP')
        await this.logradouro.prepare(orderGen++, 'Logradouro')
        await this.enderecoNumeros.prepare(orderGen++, 'Número')
        await this.enderecoComplementoTexts.prepare(orderGen++, 'Complemento')
        await this.enderecoLatitude.prepare(orderGen++, 'Latitude')
        await this.enderecoLongitude.prepare(orderGen++, 'Longitude')
        await this.telefone1.prepare(orderGen++, 'Telefone 1 - RF')
        await this.telefone2.prepare(orderGen++, 'Telefone 2 - RF')
        await this.email.prepare(orderGen++, 'E-mail')
        await this.naturezaJuridicaCodes.prepare(orderGen++, 'Natureza Jurídica')
        await this.naturezaJuridicaGrupoCodes.prepare(orderGen++, 'Natureza Jurídica - Grupos')
        await this.naturezaJuridicaPublicaPrivadaCodes.prepareFilter(
            orderGen++,
            'Natureza Jurídica - Pública/Privada',
            [
                { id: 'Pub', title: 'Pública' },
                { id: 'Pri', title: 'Privada' }
            ]
        )
        await this.tipoCnaeCodes.prepare(orderGen++, 'CNAE')
        await this.tipoEstabelecimentoSaudeCodes.prepare(orderGen++, 'Tipo de Estabelecimento de Saúde')
        await this.porteEstabelecimentoSaudeCodes.prepare(orderGen++, 'Porte do Estabelecimento de Saúde (Leitos)')
        await this.cnaeClasseCodes.prepare(orderGen++, 'CNAE Classe')
        await this.cnaeDivisaoCodes.prepare(orderGen++, 'CNAE Divisão')
        await this.cnaeGrupoCodes.prepare(orderGen++, 'CNAE Grupo')
        await this.cnaeSecaoCodes.prepare(orderGen++, 'CNAE Seção')
        await this.cnaeSetorCods.prepare(orderGen++, 'CNAE Setor')
        await this.cnesTexts.prepare(orderGen++, 'CNES')
        await this.scoreRiscos.prepare(orderGen++, 'Score Risco')

        await this.socioNome.prepare(orderGen++, 'Sócio', appStorage.tcmPartnersEnabled)
        await this.prfNome.prepare(orderGen++, 'Médico', appStorage.tcmDoctorsEnabled)
        await this.pesNome.prepare(orderGen++, 'Vínculo', appStorage.tcmRelationshipsEnabled)
        await this.totalEmpresaGrupo.prepare(orderGen++, 'Total Empresas no grupo')
        await this.totalFiliais.prepare(orderGen++, 'Total de Filiais')
        await this.totalEmpresaCapSocial.prepare(orderGen++, 'Faixa Capital Social')
        await this.totalFuncionarios.prepare(orderGen++, 'Faixa Funcionários')
        await this.totalFuncionarios_0_a_18.prepare(orderGen++, 'Qtde Func. até 18 anos')
        await this.totalFuncionarios_19_a_33.prepare(orderGen++, 'Qtde Func. 19 a 33 anos')
        await this.totalFuncionarios_34_a_48.prepare(orderGen++, 'Qtde Func. 34 a 48 anos')
        await this.totalFuncionarios_49_a_58.prepare(orderGen++, 'Qtde Func. 49 a 58 anos')
        await this.totalFuncionarios_59_ou_mais.prepare(orderGen++, 'Qtde Func. 59+ anos')
        await this.totalFuncionariosFemininos.prepare(orderGen++, 'Qtde Func. Femininos')
        await this.totalFuncionariosMasculinos.prepare(orderGen++, 'Qtde Func. Masculinos')
        await this.totalFuncionariosDoGrupo.prepare(orderGen++, 'Faixa Funcionários Grupo')
        await this.totalFuncionariosMatrizEFiliais.prepare(orderGen++, 'Total de Funcionários - Matriz + Filiais')
        await this.faixaFaturamentoAnual.prepare(orderGen++, 'Faixa Faturamento Anual')
        await this.faixaFaturamentoConsolidadoGrupo.prepare(orderGen++, 'Faixa Faturamento Grupo')
        await this.salarioTotal.prepare(orderGen++, 'Salário Total')
        await this.salarioTotalGrupo.prepare(orderGen++, 'Salário Total Grupo')
        await this.idadeEmpresa.prepare(orderGen++, 'Idade Empresa em Anos')
        await this.cboCodes.prepare(orderGen++, 'CBO - Médicos')
        await this.pesCboCodes.prepare(orderGen++, 'CBO - Vínculos')
        await this.cboCategorias.prepare(orderGen++, 'CBO - Categoria (Médicos)')
        await this.pesCboCategorias.prepare(orderGen++, 'CBO - Categoria (Vínculos)')

        await this.matrizFilial.prepareFilter(orderGen++, 'Matriz/Filial Descrição', [
            { id: '1', title: 'Matriz' },
            { id: '0', title: 'Filial' }
        ])
        await this.regimeTributario.prepare(orderGen++, 'Regime Tributário')
        await this.optanteSimples.prepare(orderGen++, 'Optante Simples')
        await this.optanteMei.prepare(orderGen++, 'Optante MEI')
        await this.porteReceitaFederal.prepare(orderGen++, 'Porte Receita Federal')
        await this.regiaoGeograficaImediataCodes.prepare(orderGen++, 'Região Geográfica Imediata')
        await this.regiaoGeograficaIntermediariaCodes.prepare(orderGen++, 'Região Geográfica Intermediária')
        await this.portePorFuncionarios.prepare(orderGen++, 'Porte por Funcionários')
        await this.portePorFaturamentoEstimadoCnpj.prepare(orderGen++, 'Porte por Fat. Estimado do CNPJ')
        await this.portePorFaturamentoEstimadoGrupo.prepare(orderGen++, 'Porte por Fat. Estimado do Grupo Econômico')
        await this.cadeiaValorSaude.prepareFilter(orderGen++, 'Cadeia de Valor da Saúde', [
            { id: '0', title: 'Não' },
            { id: '1', title: 'Sim' }
        ])
        await this.webNomeTexts.prepare(orderGen++, 'Internet - Nome')
        await this.webCategoriasTexts.prepare(orderGen++, 'Internet - Categorias')
        await this.webNota.prepare(orderGen++, 'Internet - Nota')
        await this.webQtdAvaliacoes.prepare(orderGen++, 'Internet - Total de avaliações')
        await this.webTempoMedio.prepare(orderGen++, 'Internet - Tempo Médio')
        await this.webSite.prepare(orderGen++, 'Internet - Website')
        await this.webTelefone.prepare(orderGen++, 'Internet - Telefone')

        LOG.debug('initialized')
    }

    override release(): void {
        this.filterPresenters.forEach((filter) => filter.release())
        this.catalogFilter.release()
    }

    async applyParameters(keys: TheConsumerMarketKeys, initialization: boolean) {
        await this.catalogFilter.applyParameters(keys, initialization)
    }

    clear() {
        this.filterPresenters.forEach((filter) => filter.clear())
        this.scope.enchenteRs2024.active = false

        const mgr = this.owner.filterManager
        mgr.clear()

        //this.owner.
    }

    publish() {
        const mgr = this.owner.filterManager
        mgr.enchenteRs2024 = this.scope.enchenteRs2024.active

        this.filterPresenters.forEach((filter) => filter.publish())
    }

    describeAppliedFilters(): AppliedFilterSummary[] {
        const result: AppliedFilterSummary[] = []

        const ordered = [...this.filterPresenters].sort((a, b) => a.scope.order - b.scope.order)
        for (const presenter of ordered) {
            const summary = summarizeFilterScope(presenter.scope)
            summary && result.push(summary)
        }

        const mgr = this.owner.filterManager

        if (mgr.serMatrizOrFilial.size > 0) {
            const tags = [...mgr.serMatrizOrFilial.values()].map((value) =>
                value === MatrizOrFilial.matriz ? 'Matriz' : 'Filial'
            )
            const summary = buildSummary('Matriz/Filial', tags)
            summary && result.push(summary)
        }

        const areas =
            mgr.localizacaoCircles.size +
            mgr.localizacaoRoutes.size +
            mgr.localizacaoPolygons.size +
            mgr.localizacaoUfs.size
        if (areas > 0) {
            const summary = buildSummary('Área no mapa', [areas === 1 ? '1 área' : `${areas} áreas`])
            summary && result.push(summary)
        }

        if (mgr.enchenteRs2024) {
            const summary = buildSummary('Enchente RS 2024', ['Sim'])
            summary && result.push(summary)
        }

        return result
    }

    async apply(filter: EmpresaFilter) {
        this.clear()
        this.nomeRazaoSocial.apply(filter.empresaRazaoSocial)
        this.nomeFantasia.apply(filter.empresaNomeFantasia)
        this.empresaNomeMatriz.apply(filter.empresaNomeMatriz)
        this.codigo.apply(filter.empresaCodigo)
        this.cnpjMatriz.apply(filter.empresaCnpjMatriz)
        this.cnpjGrupo.apply(filter.empresaCnpjGrupo)
        this.dtInicioAtividade.apply(filter.inicioAtividade)
        this.situacaoCadastral.apply(filter.situacaoCadastral)
        this.dtSituacaoCadastral.apply(filter.dtSituacaoCadastral)
        this.dtCompetenciaInicioAtividade.apply(filter.dtCompetenciaInicioAtividade)
        this.naturezaJuridicaCodes.apply(filter.naturezaJuridicaCodes)
        // filtro salvo com a lista de natureza no formato anterior
        this.naturezaJuridicaCodes.apply(filter.naturezaJuridicaCodeList)
        // a IA gera a natureza por texto (IAFilterBuilderCmd): fica no gerenciador, como os outros *Texts
        this.filterManager.naturezaJuridicaTexts.apply(filter.naturezaJuridicaTexts)
        this.naturezaJuridicaGrupoCodes.apply(filter.naturezaJuridicaGrupoCodes)
        this.naturezaJuridicaPublicaPrivadaCodes.apply(filter.naturezaJuridicaPublicaPrivadaCodes)
        this.filterManager.atividadeEconomicaCodes.apply(filter.atividadeEconomicaCodes)
        this.filterManager.atividadeEconomicaTexts.apply(filter.atividadeEconomicaTexts)
        this.filterManager.tipoAtividadeEconomicaCodes.apply(filter.tipoAtividadeEconomicaCodes)
        this.filterManager.tipoAtividadeEconomicaTexts.apply(filter.tipoAtividadeEconomicaTexts)
        this.tipoCnaeCodes.apply(filter.tipoAtividadeEconomicaCodes)
        this.tipoEstabelecimentoSaudeCodes.apply(filter.tipoEstabelecimentoSaudeCodes)
        this.porteEstabelecimentoSaudeCodes.apply(filter.porteEstabelecimentoSaudeCodes)
        this.cnaeClasseCodes.apply(filter.cnaeClasseCodes)
        this.filterManager.cnaeClasseTexts.apply(filter.cnaeClasseTexts)
        this.cnaeDivisaoCodes.apply(filter.cnaeDivisaoCodes)
        this.filterManager.cnaeDivisaoTexts.apply(filter.cnaeDivisaoTexts)
        this.cnaeGrupoCodes.apply(filter.cnaeGrupoCodes)
        this.filterManager.cnaeGrupoTexts.apply(filter.cnaeGrupoTexts)
        this.cnaeSecaoCodes.apply(filter.cnaeSecaoCodes)
        this.filterManager.cnaeSecaoTexts.apply(filter.cnaeSecaoTexts)
        this.cnaeSetorCods.apply(filter.cnaeSetorCods)
        this.uf.apply(filter.enderecoUfs)
        this.filterManager.enderecoUfTexts.apply(filter.enderecoUfTexts)
        this.filterManager.enderecoCidadeCodes.apply(filter.enderecoCidadeCodes)
        this.filterManager.enderecoCidadeTexts.apply(filter.enderecoCidadeTexts)
        this.cidadeCodes.apply(filter.enderecoCidadeCodes)
        this.cboCodes.apply(filter.cboCodes)
        this.cboTexts.apply(filter.cboTexts)
        this.pesCboCodes.apply(filter.pesCboCodes)
        this.pesCboTexts.apply(filter.pesCboTexts)
        this.cboCategorias.apply(filter.cboCategorias)
        this.pesCboCategorias.apply(filter.pesCboCategorias)
        this.regiaoMetropolitanaCodes.apply(filter.enderecoRegiaoMetropolitanaCodes)
        this.filterManager.enderecoRegiaoMetropolitanaTexts.apply(filter.enderecoRegiaoMetropolitanaTexts)
        this.scoreRiscos.apply(filter.scoreRiscos)
        this.filterManager.socioCodigo.apply(filter.socioCodigo)
        this.filterManager.socioKey.apply(filter.socioKey)
        this.socioNome.apply(filter.socioNome)
        this.filterManager.prfCodigo.apply(filter.prfCodigo)
        this.prfNome.apply(filter.prfNome)
        this.filterManager.pesCodigo.apply(filter.pesCodigo)
        this.pesNome.apply(filter.pesNome)
        this.totalEmpresaGrupo.apply(filter.totalEmpresasNoGrupo)
        this.totalEmpresaCapSocial.apply(filter.capitalSocial)
        this.totalFuncionarios.apply(filter.totalFuncionarios)
        this.totalFuncionarios_0_a_18.apply(filter.totalFuncionarios_0_a_18)
        this.totalFuncionarios_19_a_33.apply(filter.totalFuncionarios_19_a_33)
        this.totalFuncionarios_34_a_48.apply(filter.totalFuncionarios_34_a_48)
        this.totalFuncionarios_49_a_58.apply(filter.totalFuncionarios_49_a_58)
        this.totalFuncionarios_59_ou_mais.apply(filter.totalFuncionarios_59_ou_mais)
        this.totalFuncionariosFemininos.apply(filter.totalFuncionariosFemininos)
        this.totalFuncionariosMasculinos.apply(filter.totalFuncionariosMasculinos)
        this.totalFuncionariosDoGrupo.apply(filter.totalFuncionariosDoGrupo)
        this.faixaFaturamentoAnual.apply(filter.faturamentoEstimado)
        this.faixaFaturamentoConsolidadoGrupo.apply(filter.faturamentoEstimadoGrupo)
        this.idadeEmpresa.apply(filter.idadeEmpresaEmAnos)

        this.matrizFilial.apply(filter.matrizFilial)
        this.regimeTributario.apply(filter.regimeTributario)
        this.porteReceitaFederal.apply(filter.porteReceitaFederal)
        this.regiaoGeograficaImediataCodes.apply(filter.regiaoGeograficaImediataCodes)
        this.regiaoGeograficaIntermediariaCodes.apply(filter.regiaoGeograficaIntermediariaCodes)
        this.portePorFuncionarios.apply(filter.portePorFuncionarios)
        this.portePorFaturamentoEstimadoCnpj.apply(filter.portePorFaturamentoEstimadoCnpj)
        this.portePorFaturamentoEstimadoGrupo.apply(filter.portePorFaturamentoEstimadoGrupo)
        this.cadeiaValorSaude.apply(filter.cadeiaValorSaude)
        this.matrizUfs.apply(filter.matrizUfs)
        this.cep.apply(filter.enderecoCeps)
        this.logradouro.apply(filter.enderecoRuaTexts)
        this.enderecoNumeros.apply(filter.enderecoNumeros)
        this.enderecoComplementoTexts.apply(filter.enderecoComplementoTexts)
        this.enderecoLatitude.apply(filter.enderecoLatitude)
        this.enderecoLongitude.apply(filter.enderecoLongitude)
        this.telefone1.apply(filter.telefone1)
        this.telefone2.apply(filter.telefone2)
        this.email.apply(filter.email)
        this.totalFiliais.apply(filter.totalFiliais)
        this.totalFuncionariosMatrizEFiliais.apply(filter.totalFuncionariosMatrizEFiliais)
        this.salarioTotal.apply(filter.salarioTotal)
        this.salarioTotalGrupo.apply(filter.salarioTotalGrupo)
        this.optanteSimples.apply(filter.optanteSimples)
        this.optanteMei.apply(filter.optanteMei)
        this.webNomeTexts.apply(filter.webNomeTexts)
        this.webCategoriasTexts.apply(filter.webCategoriasTexts)
        this.webNota.apply(filter.webNota)
        this.webQtdAvaliacoes.apply(filter.webQtdAvaliacoes)
        this.webTempoMedio.apply(filter.webTempoMedio)
        this.webSite.apply(filter.webSite)
        this.webTelefone.apply(filter.webTelefone)

        this.filterManager.situacaoCadastral.apply(filter.situacaoCadastral)
        this.filterManager.serMatrizOrFilial.apply(filter.matrizOrFilial)
        this.filterManager.empresaCnes.apply(filter.empresaCnes)
        this.filterManager.empresaGrupoCodes.apply(filter.empresaGrupoCodes)
        this.filterManager.enderecoCodes.apply(filter.enderecoCodes)
        this.filterManager.enderecoTexts.apply(filter.enderecoTexts)
        this.filterManager.enderecoRuaCodes.apply(filter.enderecoRuaCodes)
        this.filterManager.enderecoBairroCodes.apply(filter.enderecoBairroCodes)
        this.filterManager.enderecoBairroTexts.apply(filter.enderecoBairroTexts)
        this.filterManager.enderecoCepTexts.apply(filter.enderecoCepTexts)
        this.filterManager.percentualFuncionariasMulheres.apply(filter.percentualFuncionariasMulheres)
        this.filterManager.inicioAtividade.apply(filter.inicioAtividade)
        this.filterManager.localizacaoCircles

        if (filter.localizacao) {
            this.filterManager.localizacaoCircles.apply(filter.localizacao.circles)
            this.filterManager.localizacaoPolygons.apply(filter.localizacao.polygons)
            this.filterManager.localizacaoUfs.apply(filter.localizacao.ufs)
            this.filterManager.localizacaoRoutes.apply(filter.localizacao.routes)
        }

        this.filterManager.enchenteRs2024 = filter.enchenteRs2024 ?? false
        this.owner.empresasMapa.plotFromFilterManager()

        await this.__handleApply()
    }

    private async __handleToggleExpantion() {
        this.scope.expanded = !this.scope.expanded
    }

    private async __handleEnchenteRs2024ActiveChange(value: boolean) {
        this.scope.enchenteRs2024.active = value
        await this.owner.fetchData('')
        this.scope.enchenteRs2024.onNotifyMap(value).catch(LOG.caught)
    }

    private async __handleSearchFilterChanged(filterText: string) {
        this.scope.searchFilterText = filterText
        this.scope.nomeEmpresa.visible = compareCaptionFilter(filterText, this.scope.nomeEmpresa.caption)
        this.scope.nomeFantasia.visible = compareCaptionFilter(filterText, this.scope.nomeFantasia.caption)
        this.scope.nomeMatriz.visible = compareCaptionFilter(filterText, this.scope.nomeMatriz.caption)
        this.scope.cnpj.visible = compareCaptionFilter(filterText, this.scope.cnpj.caption)
        this.scope.cnpjMatriz.visible = compareCaptionFilter(filterText, this.scope.cnpjMatriz.caption)
        this.scope.cnpjGrupo.visible = compareCaptionFilter(filterText, this.scope.cnpjGrupo.caption)
        this.scope.dtInicioAtividade.visible = compareCaptionFilter(filterText, this.scope.dtInicioAtividade.caption)
        this.scope.situacaoCadastral.visible = compareCaptionFilter(filterText, this.scope.situacaoCadastral.caption)
        this.scope.dtSituacaoCadastral.visible = compareCaptionFilter(
            filterText,
            this.scope.dtSituacaoCadastral.caption
        )
        this.scope.dtCompetenciaInicioAtividade.visible = compareCaptionFilter(
            filterText,
            this.scope.dtCompetenciaInicioAtividade.caption
        )
        this.scope.naturezaJuridicaCodes.visible = compareCaptionFilter(
            filterText,
            this.scope.naturezaJuridicaCodes.caption
        )
        this.scope.naturezaJuridicaGrupoCodes.visible = compareCaptionFilter(
            filterText,
            this.scope.naturezaJuridicaGrupoCodes.caption
        )
        this.scope.naturezaJuridicaPublicaPrivadaCodes.visible = compareCaptionFilter(
            filterText,
            this.scope.naturezaJuridicaPublicaPrivadaCodes.caption
        )
        this.scope.cnaeTexts.visible = compareCaptionFilter(filterText, this.scope.cnaeTexts.caption)
        this.scope.tipoCnaeTexts.visible = compareCaptionFilter(filterText, this.scope.tipoCnaeTexts.caption)
        this.scope.tipoEstabelecimentoSaudeCodes.visible = compareCaptionFilter(
            filterText,
            this.scope.tipoEstabelecimentoSaudeCodes.caption
        )
        this.scope.porteEstabelecimentoSaudeCodes.visible = compareCaptionFilter(
            filterText,
            this.scope.porteEstabelecimentoSaudeCodes.caption
        )
        this.scope.cnaeClasseCodes.visible = compareCaptionFilter(filterText, this.scope.cnaeClasseCodes.caption)
        this.scope.cnaeClasseTexts.visible = compareCaptionFilter(filterText, this.scope.cnaeClasseTexts.caption)
        this.scope.cnaeDivisaoCodes.visible = compareCaptionFilter(filterText, this.scope.cnaeDivisaoCodes.caption)
        this.scope.cnaeDivisaoTexts.visible = compareCaptionFilter(filterText, this.scope.cnaeDivisaoTexts.caption)
        this.scope.cnaeGrupoCodes.visible = compareCaptionFilter(filterText, this.scope.cnaeGrupoCodes.caption)
        this.scope.cnaeGrupoTexts.visible = compareCaptionFilter(filterText, this.scope.cnaeGrupoTexts.caption)
        this.scope.cnaeSecaoCodes.visible = compareCaptionFilter(filterText, this.scope.cnaeSecaoCodes.caption)
        this.scope.cnaeSecaoTexts.visible = compareCaptionFilter(filterText, this.scope.cnaeSecaoTexts.caption)
        this.scope.cnaeSetorCods.visible = compareCaptionFilter(filterText, this.scope.cnaeSetorCods.caption)
        this.scope.cnesTexts.visible = compareCaptionFilter(filterText, this.scope.cnesTexts.caption)
        this.scope.uf.visible = compareCaptionFilter(filterText, this.scope.uf.caption)
        this.scope.cidadeCodes.visible = compareCaptionFilter(filterText, this.scope.cidadeCodes.caption)
        this.scope.cboCodes.visible = compareCaptionFilter(filterText, this.scope.cboCodes.caption)
        this.scope.cboTexts.visible = compareCaptionFilter(filterText, this.scope.cboTexts.caption)
        this.scope.pesCboCodes.visible = compareCaptionFilter(filterText, this.scope.pesCboCodes.caption)
        this.scope.pesCboTexts.visible = compareCaptionFilter(filterText, this.scope.pesCboTexts.caption)
        this.scope.cboCategorias.visible = compareCaptionFilter(filterText, this.scope.cboCategorias.caption)
        this.scope.pesCboCategorias.visible = compareCaptionFilter(filterText, this.scope.pesCboCategorias.caption)
        this.scope.bairroTexts.visible = compareCaptionFilter(filterText, this.scope.bairroTexts.caption)
        this.scope.regiaoMetropolitanaCodes.visible = compareCaptionFilter(
            filterText,
            this.scope.regiaoMetropolitanaCodes.caption
        )
        this.scope.scoreRiscos.visible = compareCaptionFilter(filterText, this.scope.scoreRiscos.caption)
        this.scope.socioNome.visible =
            appStorage.tcmPartnersEnabled && compareCaptionFilter(filterText, this.scope.socioNome.caption)
        this.scope.prfNome.visible =
            appStorage.tcmDoctorsEnabled && compareCaptionFilter(filterText, this.scope.prfNome.caption)
        this.scope.pesNome.visible =
            appStorage.tcmRelationshipsEnabled && compareCaptionFilter(filterText, this.scope.pesNome.caption)
        this.scope.totalEmpresaGrupo.visible = compareCaptionFilter(filterText, this.scope.totalEmpresaGrupo.caption)
        this.scope.totalEmpresaCapSocial.visible = compareCaptionFilter(
            filterText,
            this.scope.totalEmpresaCapSocial.caption
        )
        this.scope.totalFuncionarios.visible = compareCaptionFilter(filterText, this.scope.totalFuncionarios.caption)
        this.scope.totalFuncionarios_0_a_18.visible = compareCaptionFilter(
            filterText,
            this.scope.totalFuncionarios_0_a_18.caption
        )
        this.scope.totalFuncionarios_19_a_33.visible = compareCaptionFilter(
            filterText,
            this.scope.totalFuncionarios_19_a_33.caption
        )
        this.scope.totalFuncionarios_34_a_48.visible = compareCaptionFilter(
            filterText,
            this.scope.totalFuncionarios_34_a_48.caption
        )
        this.scope.totalFuncionarios_49_a_58.visible = compareCaptionFilter(
            filterText,
            this.scope.totalFuncionarios_49_a_58.caption
        )
        this.scope.totalFuncionarios_59_ou_mais.visible = compareCaptionFilter(
            filterText,
            this.scope.totalFuncionarios_59_ou_mais.caption
        )
        this.scope.totalFuncionariosFemininos.visible = compareCaptionFilter(
            filterText,
            this.scope.totalFuncionariosFemininos.caption
        )
        this.scope.totalFuncionariosMasculinos.visible = compareCaptionFilter(
            filterText,
            this.scope.totalFuncionariosMasculinos.caption
        )
        this.scope.totalFuncionariosDoGrupo.visible = compareCaptionFilter(
            filterText,
            this.scope.totalFuncionariosDoGrupo.caption
        )
        this.scope.faixaFaturamentoAnual.visible = compareCaptionFilter(
            filterText,
            this.scope.faixaFaturamentoAnual.caption
        )
        this.scope.faixaFaturamentoConsolidadoGrupo.visible = compareCaptionFilter(
            filterText,
            this.scope.faixaFaturamentoConsolidadoGrupo.caption
        )
        this.scope.idadeEmpresa.visible = compareCaptionFilter(filterText, this.scope.idadeEmpresa.caption)
        this.scope.matrizFilial.visible = compareCaptionFilter(filterText, this.scope.matrizFilial.caption)
        this.scope.regimeTributario.visible = compareCaptionFilter(filterText, this.scope.regimeTributario.caption)
        this.scope.porteReceitaFederal.visible = compareCaptionFilter(
            filterText,
            this.scope.porteReceitaFederal.caption
        )
        this.scope.regiaoGeograficaImediataCodes.visible = compareCaptionFilter(
            filterText,
            this.scope.regiaoGeograficaImediataCodes.caption
        )
        this.scope.regiaoGeograficaIntermediariaCodes.visible = compareCaptionFilter(
            filterText,
            this.scope.regiaoGeograficaIntermediariaCodes.caption
        )
        this.scope.portePorFuncionarios.visible = compareCaptionFilter(
            filterText,
            this.scope.portePorFuncionarios.caption
        )
        this.scope.portePorFaturamentoEstimadoCnpj.visible = compareCaptionFilter(
            filterText,
            this.scope.portePorFaturamentoEstimadoCnpj.caption
        )
        this.scope.portePorFaturamentoEstimadoGrupo.visible = compareCaptionFilter(
            filterText,
            this.scope.portePorFaturamentoEstimadoGrupo.caption
        )
        this.scope.cadeiaValorSaude.visible = compareCaptionFilter(filterText, this.scope.cadeiaValorSaude.caption)
        this.scope.matrizUfs.visible = compareCaptionFilter(filterText, this.scope.matrizUfs.caption)
        this.scope.cep.visible = compareCaptionFilter(filterText, this.scope.cep.caption)
        this.scope.logradouro.visible = compareCaptionFilter(filterText, this.scope.logradouro.caption)
        this.scope.enderecoNumeros.visible = compareCaptionFilter(filterText, this.scope.enderecoNumeros.caption)
        this.scope.enderecoComplementoTexts.visible = compareCaptionFilter(
            filterText,
            this.scope.enderecoComplementoTexts.caption
        )
        this.scope.enderecoLatitude.visible = compareCaptionFilter(filterText, this.scope.enderecoLatitude.caption)
        this.scope.enderecoLongitude.visible = compareCaptionFilter(filterText, this.scope.enderecoLongitude.caption)
        this.scope.telefone1.visible = compareCaptionFilter(filterText, this.scope.telefone1.caption)
        this.scope.telefone2.visible = compareCaptionFilter(filterText, this.scope.telefone2.caption)
        this.scope.email.visible = compareCaptionFilter(filterText, this.scope.email.caption)
        this.scope.totalFiliais.visible = compareCaptionFilter(filterText, this.scope.totalFiliais.caption)
        this.scope.totalFuncionariosMatrizEFiliais.visible = compareCaptionFilter(
            filterText,
            this.scope.totalFuncionariosMatrizEFiliais.caption
        )
        this.scope.salarioTotal.visible = compareCaptionFilter(filterText, this.scope.salarioTotal.caption)
        this.scope.salarioTotalGrupo.visible = compareCaptionFilter(filterText, this.scope.salarioTotalGrupo.caption)
        this.scope.optanteSimples.visible = compareCaptionFilter(filterText, this.scope.optanteSimples.caption)
        this.scope.optanteMei.visible = compareCaptionFilter(filterText, this.scope.optanteMei.caption)
        this.scope.webNomeTexts.visible = compareCaptionFilter(filterText, this.scope.webNomeTexts.caption)
        this.scope.webCategoriasTexts.visible = compareCaptionFilter(filterText, this.scope.webCategoriasTexts.caption)
        this.scope.webNota.visible = compareCaptionFilter(filterText, this.scope.webNota.caption)
        this.scope.webQtdAvaliacoes.visible = compareCaptionFilter(filterText, this.scope.webQtdAvaliacoes.caption)
        this.scope.webTempoMedio.visible = compareCaptionFilter(filterText, this.scope.webTempoMedio.caption)
        this.scope.webSite.visible = compareCaptionFilter(filterText, this.scope.webSite.caption)
        this.scope.webTelefone.visible = compareCaptionFilter(filterText, this.scope.webTelefone.caption)
    }

    private async __handleClearFilters() {
        this.clear()
        await this.__handleApply()
    }

    private checkIsFiltering() {
        this.scope.isFiltering = this.filterPresenters.some(presenterIsFiltering)
    }

    private async __handleApply() {
        await this.owner.fetchData('')
        this.checkIsFiltering()
        this.catalogFilter.refreshDirtyState()
    }

    private async __getAllSituacaoCadastral(): Promise<KeywordOption[]> {
        return getAllSituacaoCadastral()
    }

    private async __searchAllCnesTipos(): Promise<KeywordOption[]> {
        return TIPOS_CNES
    }

    private async __searchAllCnesPortes(): Promise<KeywordOption[]> {
        return [
            { key: 'SL', label: 'ESTABELECIMENTO SEM LEITO' },
            { key: 'G', label: 'GRANDE PORTE' },
            { key: 'M', label: 'MÉDIO PORTE' },
            { key: 'P', label: 'PEQUENO PORTE' },
            { key: 'EX', label: 'PORTE ESPECIAL OU EXTRA' }
        ]
    }

    private async __getAllCNAE(): Promise<KeywordOption[]> {
        return getAllCNAE()
    }

    private async __getAllCNAEClasse(): Promise<KeywordOption[]> {
        return getAllCNAEClasse()
    }

    private async __getAllCNAEDivisao(): Promise<KeywordOption[]> {
        return getAllCNAEDivisao()
    }

    private async __getAllCNAEGrupo(): Promise<KeywordOption[]> {
        return getAllCNAEGrupo()
    }

    private async __getAllCNAESecao(): Promise<KeywordOption[]> {
        return getAllCNAESecao()
    }

    private async __getAllCNAESetor(): Promise<KeywordOption[]> {
        return [
            { key: 'A', label: 'A - AGRICULTURA, PECUÁRIA, PRODUÇÃO FLORESTAL, PESCA E AQÜICULTURA' },
            { key: 'B', label: 'B - INDÚSTRIAS EXTRATIVAS' },
            { key: 'C', label: 'C - INDÚSTRIAS DE TRANSFORMAÇÃO' },
            { key: 'D', label: 'D - ELETRICIDADE E GÁS' },
            { key: 'E', label: 'E - ÁGUA, ESGOTO, ATIVIDADES DE GESTÃO DE RESÍDUOS E DESCONTAMINAÇÃO' },
            { key: 'F', label: 'F - CONSTRUÇÃO' },
            { key: 'G', label: 'G - COMÉRCIO; REPARAÇÃO DE VEÍCULOS AUTOMOTORES E MOTOCICLETAS' },
            { key: 'H', label: 'H - TRANSPORTE, ARMAZENAGEM E CORREIO' },
            { key: 'I', label: 'I - ALOJAMENTO E ALIMENTAÇÃO' },
            { key: 'J', label: 'J - INFORMAÇÃO E COMUNICAÇÃO' },
            { key: 'K', label: 'K - ATIVIDADES FINANCEIRAS, DE SEGUROS E SERVIÇOS RELACIONADOS' },
            { key: 'L', label: 'L - ATIVIDADES IMOBILIÁRIAS' },
            { key: 'M', label: 'M - ATIVIDADES PROFISSIONAIS, CIENTÍFICAS E TÉCNICAS' },
            { key: 'N', label: 'N - ATIVIDADES ADMINISTRATIVAS E SERVIÇOS COMPLEMENTARES' },
            { key: 'O', label: 'O - ADMINISTRAÇÃO PÚBLICA, DEFESA E SEGURIDADE SOCIAL' },
            { key: 'P', label: 'P - EDUCAÇÃO' },
            { key: 'Q', label: 'Q - SAÚDE HUMANA E SERVIÇOS SOCIAIS' },
            { key: 'R', label: 'R - ARTES, CULTURA, ESPORTE E RECREAÇÃO' },
            { key: 'S', label: 'S - OUTRAS ATIVIDADES DE SERVIÇOS' },
            { key: 'T', label: 'T - SERVIÇOS DOMÉSTICOS' },
            { key: 'U', label: 'U - ORGANISMOS INTERNACIONAIS E OUTRAS INSTITUIÇÕES EXTRATERRITORIAIS' }
        ]
    }

    private async __getRegimeTributarioList(): Promise<KeywordOption[]> {
        return [
            { key: '10', label: 'Imune do IRPJ' },
            { key: '9', label: 'Isenta do IRPJ' },
            // Código 12 = MEI=S na Receita, mas excluído do Simples (494 empresas no tm-empresa-v25);
            // os ~17,5 milhões de MEI estão no 6 (Simples Nacional/MEI).
            { key: '12', label: 'MEI (excluído do Simples)' },
            { key: '11', label: 'Simples Nacional' },
            { key: '6', label: 'Simples Nacional/MEI' },
            { key: '8', label: 'Lucro Presumido' },
            { key: '2', label: 'Lucro Real' },
            { key: '1', label: 'Lucro Arbitrado' },
            { key: '3', label: 'Lucro Real/Arbitrado' },
            { key: '4', label: 'Lucro Presumido/Real' },
            { key: '5', label: 'Lucro Presumido/Real/Arbitrado' },
            { key: '7', label: 'Lucro Presumido/Arbitrado' }
        ]
    }
    private async __getPorteEmpresaList(): Promise<KeywordOption[]> {
        // Domínio da Receita: 01 Micro, 03 Pequena, 05 Demais. Os códigos 6 e 9 não existem
        // no dado -- ofereciam um filtro que sempre voltava vazio.
        return [
            { key: '1', label: 'Micro' },
            { key: '3', label: 'Pequena' },
            { key: '5', label: 'Demais' }
        ]
    }

    private async __searchAllCBOs() {
        return searchAllCBOs()
    }

    private async __searchAllPesCBOs() {
        return searchAllPesCBOs()
    }

    private async searchByRazaoSocial(text: string) {
        const rows = await service.searchEmpresaByRazaoSocial(text, this.filterManager.build(), ['pj-razao-social'])
        return [...new Set(rows.map((b) => b.source['pj-razao-social'] ?? ''))]
    }

    private async searchByNomeFantasia(text: string) {
        const rows = await service.searchEmpresaByNomeFantasia(text, this.filterManager.build(), ['pj-nome-fantasia'])
        return [...new Set(rows.map((b) => b.source['pj-nome-fantasia'] ?? ''))]
    }

    private async searchByNomeMatriz(text: string) {
        const rows = await service.searchMatrizByNome(text, this.filterManager.build(), ['pj-matriz-nome'])
        return [...new Set(rows.map((b) => b.source['pj-matriz-nome'] ?? ''))]
    }

    private async searchSocioByNome(text: string) {
        const rows = await service.searchSocioByNome(text, this.filterManager.build(), ['qsa_socio'])
        const rowSet = new Set<string>()
        for (const row of rows) {
            if (row.source.qsa_socio && row.source.qsa_socio.nome) {
                rowSet.add(row.source.qsa_socio.nome)
            }
        }
        return [...rowSet]
    }

    private async searchMedicoByNome(text: string) {
        const rows = await service.searchMedicoByNome(text, this.filterManager.build(), ['prf_nome'])
        const rowSet = new Set<string>()
        for (const row of rows) {
            if (row.source.prf_nome && row.source.prf_nome) {
                rowSet.add(row.source.prf_nome)
            }
        }
        return [...rowSet]
    }

    private async searchEmpregadoByNome(text: string) {
        const rows = await service.searchEmpregadoByNome(text, this.filterManager.build(), ['pes_nome'])
        const rowSet = new Set<string>()
        for (const row of rows) {
            if (row.source.pes_nome && row.source.pes_nome) {
                rowSet.add(row.source.pes_nome)
            }
        }
        return [...rowSet]
    }

    private async searchByBairroDescricao(text: string) {
        const rows = await service.searchBairroByDescricao(text, this.filterManager.build(), [
            'pj-addr-bairro-id',
            'pj-addr-bairro-nme'
        ])
        return [...new Set(rows.map((b) => b.source['pj-addr-bairro-nme'] ?? ''))]
    }

    private async searchAllUFs() {
        return getAllUFs()
    }

    private async searchAllCidades() {
        return await getAllCities()
    }

    private async __getAllRegioesMetropolitanas(): Promise<KeywordOption[]> {
        return getDominioPjOptions('regiao-metropolitana')
    }

    private async __getAllNaturezasJuridicas(): Promise<KeywordOption[]> {
        return getDominioPjOptions('natureza-juridica')
    }

    private async __getAllRegioesGeoImediatas(): Promise<KeywordOption[]> {
        return getDominioPjOptions('regiao-geo-imediata')
    }

    private async __getAllRegioesGeoIntermediarias(): Promise<KeywordOption[]> {
        return getDominioPjOptions('regiao-geo-intermediaria')
    }

    private async __getScoreRiscoList(): Promise<KeywordOption[]> {
        // Escala do score da fonte (A a E). '?' é quem não tem score: 70,9 milhões das
        // 73,4 milhões de empresas do tm-empresa-v25.
        return [
            { key: 'A', label: 'A' },
            { key: 'B', label: 'B' },
            { key: 'C', label: 'C' },
            { key: 'D', label: 'D' },
            { key: 'E', label: 'E' },
            { key: '?', label: 'Sem score (?)' }
        ]
    }

    private async __getOptanteSimplesList(): Promise<KeywordOption[]> {
        return [
            { key: 'S', label: 'Sim' },
            { key: 'N', label: 'Não' }
        ]
    }

    private async __getOptanteMeiList(): Promise<KeywordOption[]> {
        return [
            { key: 'S', label: 'Sim' },
            { key: 'N', label: 'Não' },
            { key: '?', label: 'Sem informação' }
        ]
    }
}

/**
 * Guarda a Promise da carga, não só o resultado: quem pedir a lista enquanto a primeira
 * consulta ainda está em andamento espera por ela em vez de disparar outra igual (cada uma
 * é uma varredura do índice no servidor). Falha não fica guardada: a próxima abertura do
 * filtro tenta de novo.
 */
function carregarUmaVez<T>(load: () => Promise<T>): () => Promise<T> {
    let pending: Promise<T> | undefined
    return () => {
        if (!pending) {
            const atual = load()
            pending = atual
            atual.catch(() => {
                if (pending === atual) {
                    pending = undefined
                }
            })
        }
        return pending
    }
}

const dominioPjCache = new Map<DominioPj, Promise<KeywordOption[]>>()
const DOMINIOS_PRE_CARREGADOS: DominioPj[] = [
    'regiao-metropolitana',
    'natureza-juridica',
    'regiao-geo-imediata',
    'regiao-geo-intermediaria'
]

function rotuloDoDominio(dominio: DominioPj, opcao: DominioPjOpcao) {
    if (dominio === 'natureza-juridica') {
        return `${opcao.key} - ${opcao.label}`
    }
    return opcao.uf ? `(${opcao.uf}) ${opcao.label}` : opcao.label
}

function ordemDoDominio(dominio: DominioPj) {
    // natureza jurídica pelo código (a tabela da Receita agrupa por faixa de código);
    // as demais pelo rótulo, que já começa pela UF nas regiões geográficas
    return dominio === 'natureza-juridica'
        ? (a: KeywordOption, b: KeywordOption) => Number(a.key) - Number(b.key)
        : (a: KeywordOption, b: KeywordOption) => a.label.localeCompare(b.label, 'pt-BR')
}

function getDominioPjOptions(dominio: DominioPj): Promise<KeywordOption[]> {
    let options = dominioPjCache.get(dominio)
    if (!options) {
        options = service
            .fetchDominioPj(dominio)
            .then((rows) =>
                rows
                    .map((row) => ({ key: row.key, label: rotuloDoDominio(dominio, row) }) as KeywordOption)
                    .sort(ordemDoDominio(dominio))
            )
        // falha não fica guardada: a próxima abertura do filtro tenta de novo
        options.catch(() => dominioPjCache.delete(dominio))
        dominioPjCache.set(dominio, options)
    }
    return options
}

const getAllCities = carregarUmaVez(async (): Promise<KeywordOption[]> => {
    const rows = await service.searchAllCidades(['pj-addr-cidade-id', 'pj-addr-cidade-nme', 'pj-addr-uf'], true)

    const cities = [
        ...new Set(
            rows.map((b) => {
                return {
                    key: `${b.source['pj-addr-cidade-id']}`,
                    label: `(${b.source['pj-addr-uf']}) ${b.source['pj-addr-cidade-nme']}`
                } as KeywordOption
            })
        )
    ].sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'))
    return cities
})

const getAllUFs = carregarUmaVez(async (): Promise<KeywordOption[]> => {
    const rows = await service.searchAllUFs()

    const ufs = [
        ...new Set(
            rows.map((b) => {
                return {
                    key: `${b.source['pj-addr-uf']}`,
                    label: `(${b.source['pj-addr-uf']}) ${b.source['pj-addr-uf-dsc']}`
                } as KeywordOption
            })
        )
    ]
    return ufs
})

let getAllSituacaoCadastral = async (): Promise<KeywordOption[]> => {
    const situacoesMapped = [
        { key: `${SituacaoCadastral.ativa}`, label: 'Ativa' },
        { key: `${SituacaoCadastral.baixada}`, label: 'Baixada' },
        { key: `${SituacaoCadastral.inapta}`, label: 'Inapta' },
        { key: `${SituacaoCadastral.nula}`, label: 'Nula' },
        { key: `${SituacaoCadastral.supensa}`, label: 'Suspensa' }
    ]
    getAllSituacaoCadastral = async () => Promise.resolve(situacoesMapped)
    return situacoesMapped
}

const getAllCNAE = carregarUmaVez(async (): Promise<KeywordOption[]> => {
    const rows = await service.getAllCnae()
    const rowsMapped = rows.map((b) => {
        return { key: b['pj-ae-subclasse-cod'], label: `${b['pj-ae-subclasse-cod']} - ${b['pj-ae-subclasse-dsc']}` }
    })
    return rowsMapped
})

const getAllCNAEClasse = carregarUmaVez(async (): Promise<KeywordOption[]> => {
    const rows = await service.getAllCnaeByClasse()
    const rowsMapped = rows.map((b) => {
        return { key: b['pj-ae-classe-cod'], label: `${b['pj-ae-classe-cod']}-${b['pj-ae-classe-dsc']}` }
    })
    return rowsMapped
})

const getAllCNAEDivisao = carregarUmaVez(async (): Promise<KeywordOption[]> => {
    const rows = await service.getAllCnaeByDivisao()
    const rowsMapped = rows.map((b) => {
        return { key: b['pj-ae-divisao-cod'], label: `${b['pj-ae-divisao-cod']} - ${b['pj-ae-divisao-dsc']}` }
    })
    return rowsMapped
})

const getAllCNAEGrupo = carregarUmaVez(async (): Promise<KeywordOption[]> => {
    const rows = await service.getCnaeByGrupo()
    const rowsMapped = rows.map((b) => {
        return { key: b['pj-ae-grupo-cod'], label: `${b['pj-ae-grupo-cod']} - ${b['pj-ae-grupo-dsc']}` }
    })
    return rowsMapped
})

const getAllCNAESecao = carregarUmaVez(async (): Promise<KeywordOption[]> => {
    const rows = await service.getCnaeBySecao()
    const rowsMapped = rows.map((b) => {
        return { key: b['pj-ae-secao-cod'], label: `${b['pj-ae-secao-cod']} - ${b['pj-ae-secao-dsc']}` }
    })
    return rowsMapped
})

const searchAllCBOs = carregarUmaVez(async (): Promise<KeywordOption[]> => {
    const rows = await service.getAllPrfCBOs()
    let rowsMapped = rows.map((b) => {
        return { key: String(b.cod), label: `${b.cod} - ${b.dsc}` }
    })
    rowsMapped = rowsMapped.sort((a, b) => a.label.localeCompare(b.label))
    return rowsMapped
})

const searchAllPesCBOs = carregarUmaVez(async (): Promise<KeywordOption[]> => {
    const rows = await service.getAllPesCBOs()
    let rowsMapped = rows.map((b) => {
        return { key: String(b.cod), label: `${b.cod} - ${b.dsc}` }
    })
    rowsMapped = rowsMapped.sort((a, b) => a.label.localeCompare(b.label))
    return rowsMapped
})

const searchAllPrfCboCategorias = carregarUmaVez(async (): Promise<KeywordOption[]> => {
    const rows = await service.getAllCboCategorias('prf')
    return rows.map((b) => ({ key: String(b.cod), label: b.dsc }))
})

const searchAllPesCboCategorias = carregarUmaVez(async (): Promise<KeywordOption[]> => {
    const rows = await service.getAllCboCategorias('pes')
    return rows.map((b) => ({ key: String(b.cod), label: b.dsc }))
})

function normalizeText(text: string): string {
    return text
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toUpperCase()
        .trim()
}

function compareCaptionFilter(filterText?: string, caption?: string): boolean {
    if (!caption || caption.trim().length === 0) return false
    if (!filterText) return true

    const captionWords = normalizeText(caption).split(' ')
    const filterWords = normalizeText(filterText).split(' ')

    return filterWords.every((filter) => captionWords.some((word) => word.includes(filter)))
}

const presenterIsFiltering = (filter: FilterPresenter<IFilterScope, IPresenterOwner>) => {
    const scope = filter.scope as IFilterScope & { conjunction: []; disjunction: [] }
    return scope.conjunction?.length > 0 || scope.disjunction?.length > 0
}

const TIPOS_CNES = [
    // ???? { "key": "-", "label": "CENTRAL DE ABASTECIMENTO" },
    { key: '68', label: 'CENTRAL DE GESTAO EM SAUDE' },
    { key: '82', label: 'CENTRAL DE NOTIFICACAO, CAPTACAO E DISTRIB DE ORGAOS ESTADUAL' },
    { key: '81', label: 'CENTRAL DE REGULACAO DO ACESSO' },
    { key: '76', label: 'CENTRAL DE REGULACAO MEDICA DAS URGENCIAS' },
    // { "key": "64", "label": "CENTRAL DE REGULACAO DE SERVICOS DE SAUDE" }, // ????
    { key: '71', label: 'CENTRO DE APOIO A SAUDE DA FAMILIA' },
    { key: '69', label: 'CENTRO DE ATENCAO HEMOTERAPICA E/OU HEMATOLOGICA' },
    { key: '70', label: 'CENTRO DE ATENCAO PSICOSSOCIAL' },
    // ???  { "key": "-", "label": "CENTRO DE IMUNIZACAO" },
    { key: '61', label: 'CENTRO DE PARTO NORMAL ISOLADO' },
    { key: '02', label: 'CENTRO DE SAUDE / UNIDADE BASICA' },
    { key: '36', label: 'CLINICA/CENTRO DE ESPECIALIDADE' },
    { key: '22', label: 'CONSULTORIO ISOLADO' },
    { key: '60', label: 'COOPERATIVA OU EMPRESA DE CESSAO DE TRABALHADORES NA SAUDE' },
    { key: '43', label: 'FARMACIA' },
    { key: '07', label: 'HOSPITAL ESPECIALIZADO' },
    { key: '05', label: 'HOSPITAL GERAL' },
    { key: '62', label: 'HOSPITAL/DIA - ISOLADO' },
    { key: '67', label: 'LABORATORIO CENTRAL DE SAUDE PUBLICA LACEN' },
    { key: '80', label: 'LABORATORIO DE SAUDE PUBLICA' },
    { key: '79', label: 'OFICINA ORTOPEDICA' },
    { key: '04', label: 'POLICLINICA' },
    { key: '74', label: 'POLO ACADEMIA DA SAUDE' },
    { key: '74', label: 'POLO DE PREVENCAO DE DOENCAS E AGRAVOS E PROMOCAO DA SAUDE' },
    { key: '01', label: 'POSTO DE SAUDE' },
    { key: '73', label: 'PRONTO ATENDIMENTO' },
    { key: '21', label: 'PRONTO SOCORRO ESPECIALIZADO' },
    { key: '20', label: 'PRONTO SOCORRO GERAL' },
    { key: '77', label: 'SERVICO DE ATENCAO DOMICILIAR ISOLADO(HOME CARE)' },
    { key: '75', label: 'TELESSAUDE' },
    { key: '39', label: 'UNIDADE DE APOIO DIAGNOSE E TERAPIA (SADT ISOLADO)' },
    { key: '72', label: 'UNIDADE DE ATENCAO A SAUDE INDIGENA' },
    { key: '78', label: 'UNIDADE DE ATENCAO EM REGIME RESIDENCIAL' },
    { key: '50', label: 'UNIDADE DE VIGILANCIA EM SAUDE' },
    { key: '15', label: 'UNIDADE MISTA' },
    { key: '42', label: 'UNIDADE MOVEL DE NIVEL PRE-HOSPITALAR NA AREA DE URGENCIA' },
    { key: '32', label: 'UNIDADE MOVEL FLUVIAL' },
    { key: '40', label: 'UNIDADE MOVEL TERRESTRE' },
    { key: '16', label: 'OUTROS' }
]

const NATUREZA_JURIDICA_GRUPOS: KeywordOption[] = [
    { key: '1', label: 'Administração Pública' },
    { key: '2', label: 'Entidades Empresariais' },
    { key: '3', label: 'Entidades sem Fins Lucrativos' },
    { key: '4', label: 'Pessoas Físicas' },
    { key: '5', label: 'Organizações Internacionais e Outras Instituições Extraterritoriais' }
]

const PORTE_OPTIONS: KeywordOption[] = [
    { key: '1', label: 'Micro' },
    { key: '3', label: 'Pequena' },
    { key: '5', label: 'Média' },
    { key: '6', label: 'Grande' }
]

export function loadAllCities(): Promise<KeywordOption[]> {
    return getAllCities()
}

export function loadAllUFs(): Promise<KeywordOption[]> {
    return getAllUFs()
}

export function filterCaptionMatches(filterText: string | undefined, caption: string | undefined) {
    return compareCaptionFilter(filterText, caption)
}
